import React, { useState, useEffect, useRef, Fragment } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import { Link as ScrollLink, Element , Events, animateScroll, scrollSpy, scroller } from 'react-scroll';

import Utils from '../../helper/Utils';
import parse from 'html-react-parser';

import { useQuery } from '@apollo/react-hooks';
import { GET_NEWS } from './queries';
import { INews } from '../../helper/Types';
import { getPostType } from '../../helper/constants';

import { useQueryParams, StringParam } from 'use-query-params';

import moment from 'moment';
import ReactPlayer from 'react-player'

import { VALoading, VALazyImage } from '../../components';


function NewsContainer() {
    const history = useHistory();
    const params:any = useParams();

    const [query, setQuery] = useQueryParams({
        openIndex: StringParam,
        lastIndex: StringParam
    });
    const [openIndex, setOpenIndex] = useState<string[]>([]);
    const [lastIndex, setLastIndex] = useState<string>("");
    const [countMedia, setCountMedia] = useState(0);

    const loadData = useQuery<INews>(GET_NEWS, {
        variables: {
            year: params.year,
        },
        fetchPolicy: "cache-first"
    });
    
    useEffect(() => {
        if( !loadData.loading && !loadData.error ) {
            const loadedData:any = loadData.data?.news;
            if( query.openIndex === undefined ) {
                setOpenIndex(["0"]);
            }
        }

        return() => {
        }
    }, [loadData]);


    const handleOnLoad = () => {
        setCountMedia(countMedia + 1);
    }

    const handleScroll = () => {
        if( query.openIndex !== undefined ) {
            const total = query.openIndex.split('|').length;
            console.log("countMedia / total : " + countMedia + " / " + total);
            if( countMedia === total ) {
                const idx:number = parseInt(query.lastIndex as string, 10);
                if( idx >= 0 ) {
                    console.log("[done]scroll : " + idx );
                    const target = `uid-${query.lastIndex}`;
                    scroller.scrollTo(target, {
                        duration: 500,
                        delay: 0,
                        smooth: true,
                        containerId: 'news-scroll-container'
                    });
                }
            }
        }
    }

    useEffect(() => {
        handleScroll();
    }, [countMedia]);


    useEffect(() => {
        setQuery({
            openIndex: openIndex.join('|'),
            lastIndex: lastIndex
        });
    }, [openIndex, lastIndex]);


    useEffect(() => {
        console.log("history.location.pathname");
        console.log(history.location.pathname);
        setCountMedia(0);
        setOpenIndex(["0"]);
        setLastIndex("0");
    }, [history.location.pathname]);

    // mount
    useEffect(() => {
        let _openIndex:any = [];
        if( query.openIndex !== undefined ) {
            _openIndex = query.openIndex.split('|');
            console.log(_openIndex);
            setOpenIndex(_openIndex);
        }
        if( query.lastIndex !== undefined ) {
            setLastIndex(query.lastIndex);
        }
    }, []);


    return(
        <article className="layout-contents-container">
            <h1 className="hidden">뉴스 목록</h1>


            <table className="tbl-default-v2 scroll">
                <caption>프로젝트 목록</caption>
                <thead>
                    <tr>
                        <th className="column-index">No</th>
                        <th className="column-date">Date</th>
                        <th className="column-full">Title</th>
                    </tr>
                </thead>
                <tbody id="news-scroll-container">
                    { loadData.loading && <tr><td colSpan={3} className="none"><VALoading /></td></tr> }
                    { loadData.error && <tr><td colSpan={3} className="none">에러가 발생했습니다.<br/>{loadData.error.message}</td></tr> }

                    { loadData.data?.news.length === 0 && <tr><td colSpan={3} className="none">등록된 내용이 없습니다.</td></tr> }
                    { loadData.data?.news.map((_post:any, _index:number) => {
                        const total:any = loadData.data?.news.length;
                        const video = _post.media.find((_media:any) => _media.type === "video");
                
                        let url = "";
                        let goto = null;
                        let recipient = null;
                        switch(_post.type) {
                            case "project":
                                url = `/project/${_post.uid}`;
                                goto = <button type="button" className="btn-detail" onClick={(e) => { handleBeforeClick(e, _index.toString(), url); }}>Go to project</button>
                                break;
                            case "introduction":
                                url = `/about/introduction/${_post.uid}`;
                                goto = <button type="button" className="btn-detail" onClick={(e) => { handleBeforeClick(e, _index.toString(), url); }}>Read More</button>
                                break;
                            case "end":
                                url = `/about/essay&drawing/${_post.uid}`;
                                goto = <button type="button" className="btn-detail" onClick={(e) => { handleBeforeClick(e, _index.toString(), url); }}>Read More</button>
                                break;
                            case "recruit":
                                // goto = <Link to="#" className="btn-detail">Go to Recruit</Link>
                                recipient = <a href={`mailto:${_post.recruit.recipient}`} target="__bllank" className="btn-email">{_post.recruit.recipient}</a>
                                break;
                        }

                        const handleOpen = (_index:string) => {
                            let _openIndex = [...openIndex];
                            if( !_openIndex.includes(_index) ) {
                                _openIndex.push(_index);
                            }
                            setOpenIndex(_openIndex);
                            setLastIndex(_index);
                            // console.warn("handleClick[" + _index + "] : ", _openIndex);
                        }

                        const handleClose = (e:React.MouseEvent<HTMLSpanElement, MouseEvent>, _index:string) => {
                            let _openIndex = [...openIndex];
                            if( _openIndex.includes(_index) ) {
                                const idx = _openIndex.indexOf(_index);
                                if( idx > -1 ) {
                                    _openIndex.splice(idx, 1);
                                    setOpenIndex(_openIndex);
                                    setLastIndex(_index);
                                    setCountMedia(countMedia - 1);
                                            // console.warn("handleClose[" + _index + "] : ", _openIndex);
                                }
                            }
                        }

                        const handleBeforeClick = (e:React.MouseEvent<HTMLSpanElement, MouseEvent>, _index:string, url:string) => {
                            setLastIndex(_index);
                            setQuery({
                                lastIndex: _index
                            })

                            history.push(url);
                        }

                        return(
                            <Element key={_index} name={`uid-${_index}`}>
                                <tr data-expand={openIndex.includes(_index.toString())} onClick={() => {
                                    if( !openIndex.includes(_index.toString()) ) {
                                        handleOpen(_index.toString());
                                    }
                                }}>
                                    <td className="column-index">{total - _index}</td>
                                    <td className="column-date">{moment(Number(_post.date)).format("YYYY.MM.DD")}</td>
                                    <th className="column-full">
                                        <span className="title" onClick={(e) => {
                                            if( openIndex.includes(_index.toString()) ) {
                                                handleClose(e, _index.toString());
                                            }
                                        }}>
                                            <span className="category">{getPostType(_post)}</span>
                                            {_post.title}
                                        </span>

                                        { openIndex.includes(_index.toString()) &&
                                        <div className="expand-contents">
                                            <div className="media">
                                                { video === undefined && _post.cover.length > 0 ? (
                                                    <button type="button" onClick={(e) => { handleBeforeClick(e, _index.toString(), url); }}><img src={_post.cover[0].url} alt={_post.title}
                                                        onLoad={handleOnLoad}
                                                    /></button>
                                                    // <Link to={url} onClick={(e) => { handleBeforeClick(e, _index.toString()); }}><VALazyImage src={_post.cover[0].url} alt={_post.title} /></Link>
                                                    // <Link to={url}><img src={_post.cover[0].url} alt={_post.title} /></Link>
                                                ) : (
                                                    <div className="video"><div className="inner"><ReactPlayer url={video.url} className="player" playing loop muted height="100%" width="100%"
                                                        onReady={handleOnLoad}
                                                    /></div></div>
                                                )}
                                                
                                            </div>
                                            <p>
                                                <span className="truncate-overflow">
                                                {Utils.converToBold(_post.description).split('\n').map( (_item:any, _index:number) => {
                                                    return(<Fragment key={_index}>{parse(_item)}<br/></Fragment>)
                                                })}
                                                </span>
                                                {recipient}

                                                {goto}
                                            </p>
                                        </div>
                                        }
                                    </th>
                                </tr>
                            </Element>
                        )
                    }) }
                </tbody>
            </table>

        </article>
    );
}

export default NewsContainer;

